var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role)?_c('span',{staticClass:"membership-badge",attrs:{"data-cy":"membership-badge"}},[_vm._v(" "+_vm._s(_vm.role)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }